/**
 * Returns completed years between `isoBirthday` and `now`.
 * Returns `NaN` for malformed input or future dates so callers can bail out safely.
 */
export function ageYears(isoBirthday: string, now: Date = new Date()): number {
  if (!isoBirthday || !/^\d{4}-\d{2}-\d{2}$/.test(isoBirthday)) return NaN;
  const [y, m, d] = isoBirthday.split('-').map((n) => parseInt(n, 10));
  if (!y || !m || !d) return NaN;
  const birth = new Date(Date.UTC(y, m - 1, d));
  if (Number.isNaN(birth.getTime())) return NaN;
  if (birth.getTime() > now.getTime()) return NaN;
  let age = now.getUTCFullYear() - y;
  const mNow = now.getUTCMonth() + 1;
  const dNow = now.getUTCDate();
  if (mNow < m || (mNow === m && dNow < d)) age--;
  return age;
}

/** True if we have enough information to say the user is under 18. */
export function isUnder18(isoBirthday: string | undefined, now: Date = new Date()): boolean {
  if (!isoBirthday) return false;
  const a = ageYears(isoBirthday, now);
  if (!Number.isFinite(a)) return false;
  return a < 18;
}
